<template>
    <div class="page-notice" @touchmove.prevent>
        <div class="pop-close" v-if="showClose" @click="closePage"></div>
        <div class="sep-line" v-if="showClose"></div>
        <div class="bg-notice"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showClose: false
        };
    },
    created() {
        this.showClose = this.$route.query.source ? true : false;
        this.POINT('h5_element_imp', {
            page: 'super-成长权益页',
            tgt_event_id: 'h5_ACT_hdwyhtc',
            tgt_name: 'h5-ACT-成长权益-灰度外用户弹窗'
        });
    },
    methods: {
        closePage() {
            this.$emit('OnClosePage');
        }
    }
};
</script>
<style lang="less" scoped>
@asserts: '../../../../assets/growth4.0/';
.page-notice {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;
    .pop-close {
        margin-left: 240px;
        width: 31px;
        height: 31px;
        background-image: url('../../../../assets/iconV2.5/pop-close@2x.png');
        background-size: 100% 100%;
    }
    .sep-line {
        margin-left: 240px;
        width: 1px;
        height: 30px;
        background-color: #fff;
        border: 1px dashed rgba(0, 0, 0, 0.7);
    }
    .bg-notice {
        width: 275px;
        height: 187px;
        background-image: url('@{asserts}notice-pop@2x.png');
        background-size: 100% 100%;
    }
}
</style>